import { render, staticRenderFns } from "./RadioButtonBoolean.vue?vue&type=template&id=12efd84d"
import script from "./RadioButtonBoolean.vue?vue&type=script&lang=js"
export * from "./RadioButtonBoolean.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports